










import { Component, Prop, Vue } from "vue-property-decorator";
import Knob from "./knob/knob.vue";
import * as Enumerable from "linq-es5";

import * as def from "@/definitions";
import { ColorConstruct } from "@/utilityModels/colorConstruct";

const isElement = (x: any): x is HTMLElement => x instanceof HTMLElement;

@Component({
  components: {
    Knob
  }
})
export default class GradientSelector extends Vue {
  @Prop()
  gradientColors!: [
    {
      id: number;
      color: ColorConstruct;
      position: number;
      isSelected: boolean;
      isRangeVisible: boolean;
    }
  ];

  startingX: number = 0;

  gradientSelectorWidth = 0;

  mounted() {
    this.createGradientSelectorWidth();
    window.addEventListener("resize", this.createGradientSelectorWidth);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.createGradientSelectorWidth);
  }

  createGradientSelectorWidth() {
    if (!isElement(this.$refs.gradientSelector)) return;
    this.gradientSelectorWidth = this.$refs.gradientSelector.clientWidth;
  }

  onMousemove(event: MouseEvent) {
    let moveDistance =
      ((event.clientX - this.startingX) / this.gradientSelectorWidth) * 100;
    this.$emit("onMousemove", moveDistance);
  }

  onMouseup() {
    this.$emit("onMouseup");
  }

  get selectBarStyle() {
    if (this.gradientColors.length > 1) {
      let styleText = "linear-gradient(45deg, ";
      for (var i = 0; i < this.gradientColors.length; i++) {
        if (i == this.gradientColors.length - 1) {
          styleText +=
            this.gradientColors[i].color.hex +
            " " +
            this.gradientColors[i].position +
            "%";
        } else {
          styleText +=
            this.gradientColors[i].color.hex +
            " " +
            this.gradientColors[i].position +
            "%" +
            ", ";
        }
      }
      styleText += ")";
      return {
        background: styleText
      };
    } else {
      return {
        background: this.gradientColors[0].color.hex
      };
    }
  }

  selectGradientColor(gradientColorId: number, startingX) {
    this.startingX = startingX;
    this.$emit("selectGradientColor", gradientColorId);
  }
}
